import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { ApplicationType } from '../types/application'
import { Context } from '../shared'
import { applicationMutationResolver } from './helpers/application'
import {
  SingularOrganizationEntityMutationArgs,
  singularOrganizationEntityMutationArgs
} from '../types/singular-organization-entity-mutation-args'

export const restoreApplication: GraphQLFieldConfig<
  any,
  Context,
  SingularOrganizationEntityMutationArgs
> = {
  description: 'Restore an archived application',
  type: new GraphQLNonNull(ApplicationType),
  args: singularOrganizationEntityMutationArgs,
  resolve: applicationMutationResolver('restore')
}
